export default __webpack_public_path__ + "170e0e6065209327b810f34a1c6abec0.png";